var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){return _vm.confirmarNaoAtesto()}}},[_c('i',{staticClass:"fa fa-times-circle-o"}),_vm._v(" Não Atesto")])
}
var staticRenderFns = []

export { render, staticRenderFns }